import React from 'react';

import {Themes} from '../utility/theme';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import {AdminReload} from './admin/AdminReload';
import {Subcomponent} from './subcomponent/subcomponent';
import {MainPage} from './mainPage/MainPage';
import {createStyles, makeStyles} from '@material-ui/core';
import Header from './general/header/Header';
import {Footer} from './general/Footer';
import {QrOverview} from './qr/QrOverview';
import {CategoryOverview} from './category/CategoryOverview';
import {SheetOverview} from './category/sheetPage/SheetOverview';

import {CATEGORY_PROPS} from '../globals/Constants';
import CookieModel from './general/cookieModel/CookieModel';
import {OilFinder} from './general/oilFinder/OilFinder';
import {Contact} from './general/contact/Contact';
import {Category} from './general/category/Category';
import {closeCategoriesMenu} from '../utility/DialogHelper';
import {useTranslation} from 'react-i18next';

import {SheetPdf} from "./category/sheetPage/SheetPdf";
import {HelmetProvider as RawHelmetProvider} from 'react-helmet-async';

import {LanguageMappingsContext} from "../globals/LanguageMappingsContext";

// Styling
const useStyles = makeStyles(() =>
  createStyles({
    app: {
      maxWidth: '1440px',
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'block',
    },
  })
);

export const App = () => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  type Lang = 'en' | 'de' | 'pt';
  const currentLanguage: Lang = ['en','de','pt'].includes(i18n.language) ? (i18n.language as Lang) : 'en';

  const HelmetProvider = RawHelmetProvider as unknown as React.FC<{ children: React.ReactNode }>;

  const languageMappings = {
    de: {
      title: "titleDe",
      additionalInfo: "additionalInfoDe",
      html: "htmlDe",
      pdf: "pdfDe",
      dateFormat: "DD.MM.YYYY",
    },
    en: {
      title: "titleEn",
      additionalInfo: "additionalInfoEn",
      html: "htmlEn",
      pdf: "pdfEn",
      dateFormat: "MM/DD/YYYY",
    },
    pt: {
      title: "titlePt",
      additionalInfo: "additionalInfoPt",
      html: "htmlPt",
      pdf: "pdfPt",
      dateFormat: "DD.MM.YYYY",
    },
  };

  return (
    <LanguageMappingsContext.Provider value={languageMappings}>
      <MuiThemeProvider theme={Themes.Primary}>
        <div className={classes.app}>
          <div
            id='deactivedBackground'
            className='deactiveBackground notVisible'
            onClick={() => closeCategoriesMenu()}
          ></div>
          <HelmetProvider>
          <BrowserRouter>
            <div>
              <Header></Header>
            </div>
            <Routes>
              <Route path='/' element={<MainPage />} />
              <Route path='/:language' element={<MainPage />} />
              <Route path='/category' element={<Category />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/oil-finder' element={<OilFinder />} />
              <Route path='/qrcode/:productId' element={<QrOverview />} />
              <Route
                path='/pdf/:sheetNumber/:language'
                element={<SheetPdf />}
              />
              <Route
                path='/sheet/:sheetNumber/:language'
                element={<SheetOverview />}
              />

              {CATEGORY_PROPS.map((element, key) => {
                return (
                  <Route
                    path={`/category${element.link}/:language`}
                    element={
                      <CategoryOverview
                        description={element.description}
                        image={element.image}
                        static={element.static}
                        sheeTitle={element.sheeTitle}
                        staticDetails={element.staticDetails}
                        metaDescription={element.metaDescription[currentLanguage]}
                        keywords={element.keywords[currentLanguage]}
                      ></CategoryOverview>
                    }
                    key={key}
                  ></Route>
                );
              })}
              <Route path='/Subcomponent' element={<Subcomponent />} />
                <Route path='/admin' element={<AdminReload />} />
            </Routes>
            <div>
              <Footer></Footer>
            </div>
            <CookieModel></CookieModel>
          </BrowserRouter>
          </HelmetProvider>
        </div>
      </MuiThemeProvider>
    </LanguageMappingsContext.Provider>
  );
};
